<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"></link>
<template>
    <div>
        <div> 
            <b-modal  hide-footer
                :id="modal_id"
                ref="modal"
                v-bind:title="this.alerte.id != null ? 'Modifier alerte' : 'Nouvelle alerte'"
                @show="resetModal"
                @hidden="resetModal"
                :header-bg-variant="headerBgVariant"
                :header-text-variant="headerTextVariant"
                :header-title-variant="headerTextVariant"
                >
                <template v-slot:modal-header>
                    <h5 class="modal-title text-white">
                    <b>{{alerte.id != null ? 'Modifier alerte' : 'Nouvelle alerte'}}</b>
                    </h5>
                    <i class="fa fa-times text-white" aria-hidden="true" @click="$bvModal.hide(modal_id)"></i>
                </template> 
                <form ref="form" @submit.stop.prevent="handleSubmit"  id="form">
                    <div class="mt-3" v-if="!hasPatientRole">
                        <span class="obligatoire">*</span>
                        <label for="exampleInputEmail1">Patient</label>
                        <b-form-group
                            id="patient_id"
                            v-model="alerte.patient_id"
                            :state="patientState"
                            required
                            label-for="patient-input"
                            invalid-feedback="Patient is required">
                        <multiselect v-model="alerte.patient" :state="patientState" @select="getPatient" required invalid-feedback="Patient is required" :options="patients" :multiple="false" placeholder="Patient" selectLabel="Sélectionner le patient" label="name" track-by="id" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="30" :max-height="600" :show-no-results="false" :hide-selected="true" @search-change="getSearchPatient">
                        </multiselect>
                        </b-form-group>
                    </div>
                    <div class="mt-3" v-if="!hasPatientRole && !hasSouscripteurRole">
                        <span class="obligatoire">*</span>
                        <label for="exampleInputEmail1">Souscripteur</label>
                         <b-form-group
                            id="souscripteur_id"
                            v-model="alerte.creator_id"
                            :state="souscripteurState"
                            required
                            label-for="souscripteur-input"
                            invalid-feedback="Souscripteur is required"> 
                        <multiselect v-model="alerte.creator" :state="souscripteurState" @select="getSouscripteur" required invalid-feedback="Souscripteur is required" :options="souscripteurs" :multiple="false" placeholder="Souscripteur" selectLabel="Sélectionner le souscripteur" label="name" track-by="id" :searchable="true" :loading_souscripteur="loading_souscripteur" :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="30" :max-height="600" :show-no-results="false" :hide-selected="true">
                        </multiselect>
                        </b-form-group>
                    </div>
                    <div class="mt-3">
                        <span class="obligatoire">*</span>
                        <label for="exampleInputEmail1">Niveau d'urgence </label>
                        <b-form-group
                            id="miveau-urgence"
                            v-model="alerte.niveau_urgence_id"
                            invalid-feedback="Niveau d'urgence est obligatoire"
                            :state="niveaUrgenceState"
                            required>
                            <multiselect v-model="urgence"  @select="showAlert" label="id" :options="pUrgencesAlarm" :state="niveaUrgenceState" required invalid-feedback="Niveau d'urgence is required" track-by="id" :multiple="false" placeholder="niveau d'urgence" selectLabel="Sélectionner">
                                  <!-- affichage du multiselect plié -->
                                    <template slot="singleLabel" slot-scope="{ option }">
                                        <span>{{ option.id }}</span>
                                        <!-- <span>&nbsp;{{ truncate( option.description , 18) }}</span> -->
                                    </template>
                                    <!-- affichage des options(multiselect déplié) -->
                                    <template slot="option" slot-scope="{ option }">
                                        <div class="option__desc">
                                        <span class="option__title">
                                            <strong>{{option.id}}&nbsp;</strong>
                                        </span> -
                                        <span class="option__small">{{truncate( option.description, 22) }}</span>
                                        </div>
                                    </template>
                            </multiselect>
                            <!-- <pre class="language-json"><code>{{ urgence }}</code></pre> -->
                                <!-- <b-popover :target="`popover-2-${item.id}`" placement="top" triggers="hover">
                                    <div class="">
                                        <h6 class="text-white">hello</h6>
                                    </div>
                                </b-popover> -->
                        </b-form-group>
                        <b-alert class="text-dark mt--3 small-fw" dismissible fade @dismissed="describe=false"
                            :show="describe" variant="secondary">{{urgence.description}} 
                            <a class="close float-right text-light cursor" @click="describe=false">&times;</a>
                        </b-alert>
                    </div>
                    <div class="mt-3">
                        <span class="obligatoire">*</span>
                        <b-form-group
                        label="Plaintes"
                        label-for="plainte-input"
                        invalid-feedback="Plainte est obligatoire"
                        :state="plainteState"
                        >
                        <div class="row">
                        <b-form-textarea
                        :class="isRecording? 'col-12 text-dark':'col-10 col-md-11 text-dark'"
                            id="name-input"
                            counter :rules="rules" 
                            v-model="text"
                            :state="plainteState"
                            placeholder="Entrez votre plainte"
                            required
                        ></b-form-textarea>
                        <div id="browser" v-if="this.browserName != 'Mozilla Firefox'" class='col-2 col-md-1 mt-3'>
                        <v-btn d-flex dark @click.stop="toggle ? endSpeechRecognition() : startSpeechRecognition()" icon :color="!toggle ? 'primary' : speaking ? 'red lighten-2' : 'red darken-4'" :class="{ pulse: toggle }">
                                 <div v-if="mediaRecorder">
                                            <slot :isRecording="isRecording"
                                                :startRecording="startRecording"
                                                :stopRecording="stopRecording"
                                                :deleteRecording="deleteRecording">
                                                <i v-if="!isRecording" @click="startRecording" class="cursor fa fa-microphone fa-2x px-1 text-green" aria-hidden="true"></i>
                                            </slot>
                                        </div>
                                           <!-- <vue-dictaphone @stop="handleRecording($event)" mime-type="audio/mp3" 
                                        </vue-dictaphone> -->

                        </v-btn></div>
                    </div>
                        <!-- <b-btn class="mt-3 text-red" v-if='hasText' @click='cleanReset' small dense>Reset</b-btn> -->
                            <div class="music-player mt-4" v-if="alerte.audio">
                                <audio controls>
                                    <source :src="alerte.audio" type="audio/mpeg">Your browser does not support the audio tag.
                                </audio>
                            </div>
                            <div class="music-player mt-4" v-if="alerte.audio1">
                                <audio controls>
                                    <source :src="alerte.audio1" type="audio/mpeg">Your browser does not support the audio tag.
                                </audio>
                            </div>
                            
                            <div class="row">
                            <div><vue-dictaphone-spectrum-analyser :style="{ opacity: isRecording ? .5 : .5, display:'block', width: '400px' }" class="my-1 w-100" v-if="isRecording"/></div> </div> 
                            <div class="py-1" v-if="isRecording"><p class="text-danger">La durée maximale est de 3 minutes</p></div>
                            <div v-if="audioSource" class="audio-sound d-flex justify-content-start mt-2">
                                <audio controls><source :src="audioSource" type="audio/mpeg"></audio>
                                <li class="alert-icon del list-none ml-2 mt-3"><i @click="deleteRecording" class="pointer fas fa-trash text-red"></i></li>
                            </div>
                        </b-form-group>
                        <div class="d-flex justify-content-center">
                            <div class="p-2">
                                <h1 class="text-center" v-if="countAudio>0">{{ convertMsToMin }}</h1>
                            </div>
                            <div class="p-2">
                                <i v-if="isRecording" @click="stopRecording" class="pointer fa fa-microphone-slash fa-2x px-1 text-red" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <!-- <button class="btn btn-danger mt-3" @click="closeModal">Fermer</button> -->
                        <b-button variant="success" v-if="this.alerte.id == null" class="mt-1" @click="handleSubmit">Soumettre</b-button>
                        <b-button variant="success" v-if="this.alerte.id" class="mt-3" @click="handleUpdate">Modifier</b-button>

                        <!--  -->
                    </div>
                </form>
            </b-modal>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import Swal from 'sweetalert2';
import Vue from 'vue';
import {mapGetters} from "vuex";
import Multiselect from 'vue-multiselect'
import AppConfig from "../../constants/AppConfig";
import axios from 'axios';
// import VueRecord from '@codekraft-studio/vue-record'
import Dictaphone from '@/components/Dictaphone';
import BaseSelected from '@/components/BaseSelected.vue'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import AlertLayout from '../../layout/AlertLayout.vue';
import NotificationInfo from "../../layout/NotificationInfo.vue";

// Vue.use(VueRecord);

const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
const recognition = SpeechRecognition ? new SpeechRecognition() : false;

 const deviceInfos = navigator.mediaDevices.enumerateDevices();

export default {
    name: "ModalAlerte",
    props: {
        mimeType: {
        type: String,
        default: 'audio/mp3',
        },
        alerte: Object,
        modal_id: String,
    },

    components: {
        BaseSelected,
        Autocomplete,
        NotificationInfo,
        Multiselect,
        AlertLayout,
        Dictaphone
    },
    computed: {
        ...mapGetters(["errors", 'hasPatientRole', "hasSouscripteurRole", 'hasAssistante', 'hasAdminRole', 'hasGestionnaireRole','alertes','urgences']),

        hasText() {
            return this.text.length > 0 ? true : false;
        },

        pUrgencesAlarm: function(){
            let mArray = [];
            _.forEach(this.urgences, function(urgence) {
                // console.log(urgence.id);
                // urgence =  urgence.description;
                let id =  urgence.id;
                let description =  urgence.description;
                mArray.push({id: id, description: description});
            });
            return mArray;
        },
        convertMsToMin(){
            const m = Math.floor(this.countAudio % 3600 / 60).toString().padStart(2,'0'),
            s = Math.floor(this.countAudio % 60).toString().padStart(2,'0');
            return  m + ':' + s;
        },
    },
    
    data() {
        return {
            browserName: null,
            audioBlob: null,
            mediaRecorder: null,
            isRecording: false,
            audioSource: null,
            recordMode: {
                audio: 'press',
                video: 'press'
            },
            recordings: [],
            lang: "fr",
            error: false,
            speaking: false,
            toggle: false,
            runtimeTranscription: "",
            sentences: [],
            text: this.alerte.plainte ? this.alerte.plainte : "",
            rules: [(v) => v.length <= 5000 || "Max 5,000 characters"],
            describe: false,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            urgence:  {id: this.alerte.niveau_urgence_id, description: this.alerte.niveau_urgence_id},
            recordingFile: [],
            audioRecord: false,
            liste_souscripteur: [],
            souscripteurs: [],
            loading: false,
            loading_souscripteur: false,
            patientState: {},
            souscripteurState: null,
            niveaUrgenceState: null,
            plainteState: this.alerte.plainte,
            submittedNames: [],
            alertForm: false,
            settings: false,
            singleAlert:{},
            Home: false,
            mobileView: true,
            uuid: this.$route.query.uuid,
            search: "",
            dismissSecs: 100,
            dismissCountDown: 0,
            countAudio: 0,
            patients: []
        }
    },

    methods: {
        stopRecording() {
            this.isRecording = false;
            this.mediaRecorder.stop();
            clearInterval(this.countInterval);
            this.endSpeechRecognition();
        },
        chromeAudio() {
            this.countInterval = setInterval(() => {
                this.countAudio += 1;
                /** 5 minutes */
                if (this.countAudio == AppConfig.dureeVocal) {
                this.stopRecording() ;
                }
            }, 1000);
        },
        startRecording() {
            this.countAudio=0;
            this.audioSource=null;
            this.chromeAudio();
            this.isRecording = true;
            this.mediaRecorder.start();
        },
        pauseRecording() {
            this.isRecording = false;
            this.mediaRecorder.pause();
        },
        deleteRecording() {
            this.error = false;
            this.speaking = false;
            this.toggle = false;
            this.runtimeTranscription = "";
            this.sentences = [];
            this.text = this.alerte.plainte == undefined ? '' : this.alerte.plainte;
            this.audioSource = null;
            this.audioBlob = null;
            this.countAudio = 0;
            this.recordingFile = [];
        },
        handleRecording({ blob, src }) {
            this.recordingFile = blob;
            this.audioSource = src;
        },
        onResult (data) {
            // console.log('The blob data:', data);
            // console.log('Downloadable audio', window.URL.createObjectURL(data));
            this.recordings.push({
                src: window.URL.createObjectURL(data)
            })
        },
        cleanReset() {

        },
        speechEnd({ sentences, text }) {
            // console.log(recognition);
            this.sentences = sentences;
            this.text = text;
        },
        checkCompatibility() {
            if (!recognition) {
                this.error = "Speech Recognition is not available on this browser. Please use Chrome or Firefox";
            }
        },
        endSpeechRecognition() {
            recognition.stop();
            this.toggle = false;
            this.speaking = false;


            setTimeout(() => {
                this.speechEnd({
                    sentences: this.sentences,
                    text: `${this.alerte.plainte == undefined ? '' : this.alerte.plainte+'.'} ${this.sentences.join(". ")}`
                });
            }, 1000);
        },
        startSpeechRecognition() {
            this.toggle = true;

            recognition.lang = this.lang;
            recognition.continuous = true;
            recognition.interimResults = true;
            recognition.maxAlternatives = 1;

            recognition.onspeechstart = () => {
                this.speaking = true;
            };

            recognition.onspeechend = () => {
                this.speaking = false;
            };

            recognition.onresult = (event) => {
                if (typeof event.results === "undefined") {
                recognition.stop();
                return;
                }
                if (this.text.length >= 1) {
                this.sentences = [];
                }

                for (var i = event.resultIndex; i < event.results.length; ++i) {
                    if (event.results[i].isFinal) {
                        let finalSentence = event.results[i][0].transcript;

                        this.runtimeTranscription = event.results[i][0].transcript;

                        this.sentences.push(this.capitalizeFirstLetter(finalSentence));
                    } else {
                        this.runtimeTranscription = event.results[i][0].transcript;
                    }
                }
            };

            recognition.start();
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        showAlert() {
            this.describe = true
        },
        deleteAlerte(alerte) {
            let args = {
                alerte: alerte,
            };
            let successMessage = this.$i18n.t('message.alertDeleted');
            let errorMessages = {
                generic: this.$i18n.t('message.genericError'),
                error: this.$i18n.t('message.error')
            };

            this.$store.dispatch('deleteAlerte', {args, successMessage, errorMessages})
            .then(() => {
                this.getAlertes();
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            });

            this.$nextTick(() => {
                this.$bvModal.hide('delete-modal-' + args.alerte);
            })
        },
        getPatient(patient){
            this.patientState = patient;
            console.log("patient ", patient.id)
            this.getSouscripteurs(patient.id);
        },
        getSouscripteur(souscripteur){
            this.souscripteurState = souscripteur
        },
        getSearchPatient(patient){
            if(patient != ""){
                this.loading = true;
                fetch(AppConfig.apiUrl+`/v2/patients?search=${patient}`, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                .then(res => {
                    this.loading = false;
                    this.patients = res.data.map(patient => ({name: patient.user.name , id: patient.user_id }));
                }).catch(error => {
                    console.log('error ', error);
                })
            }
        },
        getSouscripteurs(patient_id) {
            fetch(AppConfig.apiUrl+'/patients/souscripteurs?patient_id='+patient_id, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
            .then(res => res.json())
            .then(res => {
                this.loading_souscripteur = false;
                this.souscripteurs = res.souscripteurs.map(souscripteur => ({name: souscripteur.user.name, id: souscripteur.user_id }))
            }).catch(error => {
                console.log('error ', error);
            })
        },
        truncate(str, n){
            return (str.length > n) ? str.slice(0, n-1) + '...' : str;
        },
        formattedDateTime(date) {
            if (moment(date).isValid() && date != null) {
                return moment(date).format("DD-MM-YYYY à HH:mm");
            } else {
                return date;
            }
        },
        checkFormValidity() {
            const valid = this.$refs.form.checkValidity()
            // this.nameState = valid
            this.patientState = valid
            this.souscripteurState = valid
            this.niveaUrgenceState = valid
            this.plainteState = valid
            
            return valid
        },
        resetModal() {
            this.plainte = ''
            this.patient_id = ''
            this.niveau_urgence_id = ''
            this.souscripteur_id = ''

            // this.nameState = null
            this.patientState = {}
            this.souscripteurState = null
            this.niveaUrgenceState = null
            this.plainteState = null
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },
        handleSubmit(event) {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                // Swal.fire(
                //     'Oups !',
                //     "Une erreur a été rencontrée, veuillez réessayer s'il vous plaît !",
                //     'error'
                // )
                return
            }
                // Push the name to submitted names
                this.submittedNames.push(this.alerte)
                let args = {};
                let formData = new FormData(), file = null;
                if(!Array.isArray(this.recordingFile)){
                    let blob = new Blob([this.recordingFile], { type: "audio/mp3" });
                        file = new File([blob], 'audio.mp3');
                }

                if(this.hasPatientRole){
                    formData.append("niveau_urgence_id", this.urgence.id);
                    formData.append("plainte", this.text);
                    formData.append("patient_id", (JSON.parse(localStorage.getItem('user')))['id']);
                }
                else if (this.hasAssistante){
                    formData.append("patient_id", this.alerte.patient.id); // this should be your image
                    formData.append("niveau_urgence_id", this.urgence.id);
                    formData.append("plainte", this.text);
                    formData.append("creator_id", this.alerte.creator.id);
                }
                else if (this.hasSouscripteurRole){
                    formData.append("patient_id", this.alerte.patient.id); // this should be your image
                    formData.append("niveau_urgence_id", this.urgence.id);
                    formData.append("plainte", this.text);
                    formData.append("creator_id", (JSON.parse(localStorage.getItem('user')))['id']);
                }

                if(!Array.isArray(this.recordingFile)){
                    formData.append('audio', file);
                }
                let successMessage = this.$i18n.t('message.alerteCreated');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                // this.loading = true;

                this.$store.dispatch('createMalerte', {args: formData, errorMessages, successMessage })
                .then(() => {
                    this.$emit('clickClose');
                    this.describe=false;
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                    this.deleteRecording();
                    this.urgence.id = "";
                    this.alerte.patient = {};
                    this.alerte.creator = {};
                    this.urgence.id = "";
                });
                // this.$router.go();
                // Hide the modal manually
                this.$nextTick(() => {
                this.$bvModal.hide(this.modal_id)
            })
        },
        closeModal() {
            this.$emit('clickClose');
        },
        handleUpdate() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                return
            }
                // Push the name to submitted names
                this.submittedNames.push(this.alerte)

                let formData = new FormData(), file = null;


                if(!Array.isArray(this.recordingFile)){
                    let blob = new Blob([this.recordingFile], { type: "audio/mp3" });
                        file = new File([blob], 'audio.mp3');
                }

                if(this.hasPatientRole){
                    formData.append("niveau_urgence_id", this.urgence.id);
                    formData.append("plainte", this.text);
                    formData.append("patient_id", (JSON.parse(localStorage.getItem('user')))['id']);
                }
                else if (this.hasAssistante){
                    formData.append("patient_id", this.alerte.patient.id); // this should be your image
                    formData.append("niveau_urgence_id", this.urgence.id);
                    formData.append("plainte", this.text);
                    formData.append("creator_id", this.alerte.creator.id);
                }
                else if (this.hasSouscripteurRole){
                    formData.append("patient_id", this.alerte.patient.id); // this should be your image
                    formData.append("niveau_urgence_id", this.urgence.id);
                    formData.append("plainte", this.text);
                    formData.append("creator_id", (JSON.parse(localStorage.getItem('user')))['id']);
                }
                formData.append("_method", 'PATCH');
                if(!Array.isArray(this.recordingFile)){
                    formData.append('audio', file);
                }

                let successMessage = this.$i18n.t('message.alerteCreated');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                axios.post(AppConfig.apiUrl + '/v2/alertes/'+this.alerte.id, formData, {
                    headers: { 'Authorization': "Bearer " + localStorage.getItem('ms-token'), 'Content-Type': 'multipart/form-data' }

                }).then(res => {
                    Vue.swal( "Alerte modifiée avec succès!", '', 'success');

                    this.$emit('clickClose');
                    this.$store.commit('getAlerteHandler', res.data);
                    let data = this.alertes.data.map(item => item.id == res.data.id ? res.data : item);
                    let alertes = {...this.alertes, data: data};
                    this.$store.commit('getAlertesHandler', { alertes: alertes });
                    this.deleteRecording();
                    this.urgence.id = "";
                    this.alerte.patient = {};
                    this.alerte.creator = {};
                    this.urgence.id = "";

                }).catch(error => {
                    console.log('error ', error);
                });

                this.$nextTick(() => {
                    this.$bvModal.hide(this.modal_id)
                })
        },
        getAlertes(page = 1, search = "", size = 25, statut_id = "") {
            let args = {
                page: page,
                search: search,
                size: size,
                statut_id: statut_id,
            };

            this.$store.dispatch('getAlertes', { args : args });
        },

        getNiveauUrgence() {
            let args = {
                offset: this.offset,
                limit: this.limit,
                // id:(JSON.parse(localStorage.getItem('user')))['id']
            };

            this.$store.dispatch('getNiveauUrgence', { args : args });
        },
        goAlerte(){
            router.push('/alertes')
            // router.push({ name: '/alertes', params: { uuid: 'item.uuid' } })  
        },
        infoModal(cmd) {
          this.settings=true,  
            this.$bvModal.show('modalInfo');
            this.singleAlert=cmd

        },

        handleView() {
            this.mobileView = window.innerWidth <= 990;
        },
    },
    watch: {
        audioBlob() {
        this.$emit('stop', {
            blob: this.audioBlob,
            src: URL.createObjectURL(this.audioBlob),
        });
        this.recordingFile=this.audioBlob,
        this.audioSource=URL.createObjectURL(this.audioBlob)
        },
        
    },
    created() {
            this.browserName = (function (agent) {        
                switch (true) {
                    case agent.indexOf("edge") > -1: return "MS Edge";
                    case agent.indexOf("edg/") > -1: return "Edge ( chromium based)";
                    case agent.indexOf("opr") > -1 && !!window.opr: return "Opera";
                    case agent.indexOf("chrome") > -1 && !!window.chrome: return "Chrome";
                    case agent.indexOf("trident") > -1: return "MS IE";
                    case agent.indexOf("firefox") > -1: return "Mozilla Firefox";
                    case agent.indexOf("safari") > -1: return "Safari";
                    default: return "other";
                }
            })(window.navigator.userAgent.toLowerCase());

        // document.getElementById("browser").innerText="You are using "+ browserName +" browser"; 
        // console.log(browserName !== 'Mozilla Firefox');
    },
    async mounted() {

        if(this.uuid != undefined){
            this.$bvModal.show("modal-"+this.uuid);
        }

        this.checkCompatibility();

        let stream;
        try {
            stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        } catch (error) {
            this.$emit('error', '`navigator.mediaDevices.getUserMedia()` failed.');
            return Promise.resolve();
        }
        const recorder = new MediaRecorder(stream);
        let chunks = [];
        recorder.addEventListener('stop', () => {
            this.audioBlob = new Blob(chunks, { type: this.mimeType });
            chunks = [];
        });
            recorder.addEventListener('dataavailable', (e) => {
            chunks.push(e.data);
        });
        this.mediaRecorder = recorder;
    },
    beforeDestroy() {
        recognition.abort();
    }
    
}
</script>
<style>
/* @keyframes pulse {
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.35, 1.35, 1.35);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
} */

.pulse {
  animation-name: pulse;
  animation-fill-mode: both;
  animation-duration: 1s;
  animation-delay: 1s;
  animation-iteration-count: infinite;
}
.mike {
    position: relative;
    left: 0%;
    top: -45%;
}
.audio-sound {
    margin-top: 1%;
}

.trash-icone {
    margin-top: -27%;
    margin-left: 95%;
}
.pointer {
    cursor: pointer;
}
</style>